import moment from "moment";
import { mapActions } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";
export default {
    props: ["item"],
    name: "archive-orders",
    data() {
        return {
            openitemInfo: false,
        };
    },
    components: {
        VueSlideToggle,
    },
    methods: {
        ...mapActions({}),
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    },
};
